"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQuestionFromRaw = exports.createUpdateAllowedCondition = exports.createValueCondition = exports.createViewCondition = void 0;
const relative_date_str_1 = require("./utils/relative-date-str");
const validators_1 = require("./validation/validators");
const staticConditions_1 = require("./conditionals/staticConditions");
const dynamicConditions_1 = require("./conditionals/dynamicConditions");
const createOptions = (raw) => {
    if (raw.allowOther) {
        raw.options = (raw.options || []).concat('A_other::A_other');
    }
    return (raw.options || [])
        .map((rawOption) => {
        try {
            const [label, value, note] = rawOption.split('::');
            return { label, value, note };
        }
        catch {
            return undefined;
        }
    })
        .filter(Boolean);
};
const createPopupFromRaw = (popup) => {
    const [name, needValue, next] = (popup || '').split('::');
    return { name: name, needValue: needValue == 'true', next: next };
};
const createViewCondition = (rule) => {
    if (!rule) {
        return undefined;
    }
    const conditions = rule.split(' && ');
    return (0, staticConditions_1.createStaticConditionController)(conditions);
};
exports.createViewCondition = createViewCondition;
const createValueCondition = (rule) => {
    if (!rule) {
        return undefined;
    }
    const conditions = rule.split(' && ');
    return (0, dynamicConditions_1.createDynamicConditionController)(conditions);
};
exports.createValueCondition = createValueCondition;
const createUpdateAllowedCondition = (rule) => {
    if (!rule) {
        return undefined;
    }
    const conditions = rule.split(' && ');
    return (0, staticConditions_1.createStaticConditionController)(conditions);
};
exports.createUpdateAllowedCondition = createUpdateAllowedCondition;
const createQuestionFromRaw = (raw = undefined, overrides = {}, metaData = {}) => {
    if (!raw)
        return;
    try {
        const { text } = raw;
        let _value = raw.value;
        let _lastValidValue = raw.value;
        let _popup = createPopupFromRaw(raw.popup);
        if (overrides[text]) {
            _value = overrides[text];
        }
        if (typeof _value == 'undefined') {
            _value = raw.type === 'date' ? (0, relative_date_str_1.relativeDateFromString)(raw.defaultValue) : raw.defaultValue;
            _lastValidValue = _value;
        }
        if (raw.type === 'customList') {
            const sourceMetadata = metaData[raw.customMetadataField] || null;
            _value = sourceMetadata;
            // populate images if exist
            if (_value) {
                _value.forEach((item) => {
                    const images = raw.images[item.name] || raw.images['T_other'];
                    if (images) {
                        item.image = images;
                    }
                });
            }
        }
        const question = {
            ...raw,
            questionId: String(raw.questionId),
            options: createOptions(raw),
            minDate: (0, relative_date_str_1.relativeDateFromString)(raw.minDate),
            maxDate: (0, relative_date_str_1.relativeDateFromString)(raw.maxDate),
            validator: validators_1.ValidatorsFactory.createFromRaw(raw),
            isHide: (0, exports.createViewCondition)(raw.viewCondition),
            isValueValid: raw.metadata?.valueCondition ? (0, exports.createValueCondition)(raw.metadata?.valueCondition) : null,
            isUpdateAllowed: raw.metadata?.updateCondition ? (0, exports.createUpdateAllowedCondition)(raw.metadata?.updateCondition) : null,
            setInternalValue(value) { _value = value; },
            getInternalValue() { return _value; },
            isEmpty() {
                return (_value == undefined ||
                    _value == null ||
                    _value == '' ||
                    (_value == '+972 ' && this.type == 'phone') ||
                    (_value == '+1 ' && this.type == 'phone') ||
                    (_value == 0 && this.type == 'number') ||
                    (_value == 'אחר' && this.type == 'pickList' && this.allowOther));
            },
            getPopup() {
                if ((_popup.needValue && !this.isEmpty()) ||
                    (_popup.name && !_popup.needValue)) {
                    return {
                        name: _popup.name || '',
                        next: _popup.next || '',
                    };
                }
                return {
                    name: '',
                    next: '',
                };
            },
            isDone() {
                return (!this.hide &&
                    !this.isEmpty() &&
                    !(this.value === '$_BOOL_false') &&
                    (!this.validator || this.validator?.errors.length === 0));
            },
            lastValidValue() {
                return _lastValidValue;
            },
            setLastValidValue(value) {
                _lastValidValue = value;
            },
            get value() {
                return _value;
            },
            set value(newValue) {
                if (newValue !== _value) {
                    let isValid = false;
                    if (this.validator) {
                        isValid = this.validator.validate(newValue);
                    }
                    else {
                        isValid = true;
                    }
                    _value = newValue;
                    if (isValid || this.isEmpty()) {
                        _lastValidValue = newValue;
                    }
                }
            },
            syncValue(newValue) {
                _value = newValue;
            },
            validateValueCandidate(value) {
                let result = [];
                const v = this.validator;
                if (v && !v.validate(value)) {
                    result = v.errors;
                }
                return result;
            },
        };
        return question;
    }
    catch {
        return undefined;
    }
};
exports.createQuestionFromRaw = createQuestionFromRaw;
